<template>
  <div class="warranty-label text--center">
    <LinkButton
      text
      class="warranty-label__btn"
      @click="open"
    >
      Infos zur gesetzlichen Gewährleistungspflicht
      <Arrow
        class="warranty-label__arrow"
        direction="right"
        tag="span"
      />
    </LinkButton>
  </div>
</template>

<script setup lang="ts">
import { LinkButton, Arrow } from '@i22team/td-longtail-vue-components';
import { openModal } from '~/composables/modal';
import CdnImage from '~/components/cdn-image.vue';

const open = () => {
  openModal({
    heading: 'Gesetzliche Gewährleistungspflicht',
    component: {
      is: markRaw(CdnImage),
      props: {
        src: '/content/content-images/official/ca04e49f46b2454f4672062ef4ad47d2/eu-guarantee-notice.svg',
        alt: 'Harmonisierte Mitteilung über das gesetzliche Gewährleistungsrecht',
        renderWithoutFigure: true,
      },
    },
  });
};
</script>

<style scoped lang="scss">
.warranty-label {
  margin-bottom: 2rem;
  &__arrow {
    --arrow-position: relative;
  }
}
</style>
